"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ApiErrorCode;

(function (ApiErrorCode) {
  ApiErrorCode[ApiErrorCode["HealthCheckFailed"] = 50503] = "HealthCheckFailed";
  ApiErrorCode[ApiErrorCode["FeatureIsNotSupportedOrImplemented"] = 59010] = "FeatureIsNotSupportedOrImplemented";
  ApiErrorCode[ApiErrorCode["ServiceIsNotEnabled"] = 59020] = "ServiceIsNotEnabled";
  ApiErrorCode[ApiErrorCode["SecurityRoleIsMandatory"] = 59030] = "SecurityRoleIsMandatory";
  ApiErrorCode[ApiErrorCode["DimensionMetricCombinationIsNotValid"] = 51010] = "DimensionMetricCombinationIsNotValid";
  ApiErrorCode[ApiErrorCode["CannotGetParseArguments"] = 51020] = "CannotGetParseArguments";
  ApiErrorCode[ApiErrorCode["TooManyWaysGettingData"] = 51030] = "TooManyWaysGettingData";
  ApiErrorCode[ApiErrorCode["FailedToParseName"] = 51040] = "FailedToParseName";
  ApiErrorCode[ApiErrorCode["DuplicatedIncorrectObjectName"] = 51050] = "DuplicatedIncorrectObjectName";
  ApiErrorCode[ApiErrorCode["FailedParseExpression"] = 51060] = "FailedParseExpression";
  ApiErrorCode[ApiErrorCode["InvalidNodeOrLink"] = 51070] = "InvalidNodeOrLink";
  ApiErrorCode[ApiErrorCode["DimensionsMetricsAreNotLinked"] = 51080] = "DimensionsMetricsAreNotLinked";
  ApiErrorCode[ApiErrorCode["DimensionsMetricsIncorrectRelations"] = 51090] = "DimensionsMetricsIncorrectRelations";
  ApiErrorCode[ApiErrorCode["BadDataModelName"] = 51220] = "BadDataModelName";
  ApiErrorCode[ApiErrorCode["BadScopeName"] = 51230] = "BadScopeName";
  ApiErrorCode[ApiErrorCode["FailedGettingDimensionNodes"] = 51240] = "FailedGettingDimensionNodes";
  ApiErrorCode[ApiErrorCode["FailedGettingMetricNodes"] = 51250] = "FailedGettingMetricNodes";
  ApiErrorCode[ApiErrorCode["FailedGettingCubesTables"] = 51260] = "FailedGettingCubesTables";
  ApiErrorCode[ApiErrorCode["FailedReadConfiguration"] = 51300] = "FailedReadConfiguration";
  ApiErrorCode[ApiErrorCode["FailedReadDataModel"] = 52010] = "FailedReadDataModel";
  ApiErrorCode[ApiErrorCode["FailedCloseReader"] = 53010] = "FailedCloseReader";
  ApiErrorCode[ApiErrorCode["FailedToCast"] = 53020] = "FailedToCast";
  ApiErrorCode[ApiErrorCode["UnsupportedEncoding"] = 53030] = "UnsupportedEncoding";
  ApiErrorCode[ApiErrorCode["ScopeIsMandatory"] = 55010] = "ScopeIsMandatory";
  ApiErrorCode[ApiErrorCode["MetricIsMandatory"] = 55020] = "MetricIsMandatory";
  ApiErrorCode[ApiErrorCode["DataModelNameIsMandatory"] = 55030] = "DataModelNameIsMandatory";
  ApiErrorCode[ApiErrorCode["FailedExecuteQuery"] = 56010] = "FailedExecuteQuery";
  ApiErrorCode[ApiErrorCode["DimensionsMetricsNotCompatible"] = 57010] = "DimensionsMetricsNotCompatible";
})(ApiErrorCode = exports.ApiErrorCode || (exports.ApiErrorCode = {}));